module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("His Leading Man")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Ashlyn Kane")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He wrote a comedy. Fate directed a romance.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Drew Beaumont is bored of the same old roles: action hero, supervillain, romantic lead. He’s not going to let a fresh gay buddy comedy languish just because they can’t find him the right costar. No, Drew bats his eyelashes and convinces everyone that the movie’s writer should play Drew’s not-so-straight man.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Aspiring writer Steve Sopol has never had a screenplay optioned. Now one of Hollywood’s hottest properties wants to be in a movie Steve hasn’t finished writing—and he wants Steve as his costar. Turns out the chemistry between them is undeniable—on and offscreen.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Drew swore off dating in the biz, but Steve is the whole package: sharp, funny, humble, and cute. For Steve, though, giving in to the movie magic means the end of the privacy he cherishes. Will the credits roll before their ride into the sunset?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0